export type NestedPayload = Record<'time' | string, string | number>;

export type ChartPayloadItem = {
  dataKey: string;
  value: number | string;
  payload: NestedPayload;
};

export enum PATIENT_STATUS {
  IN_BED = 'inBed',
  NO_DATA = 'noData',
  OUT_OF_BED = 'noDataOutOfBed',
  DEVICE_DISCONNECTED = 'noDataDisconnectedDevice',
}
